
























import { defineComponent, computed } from '@vue/composition-api';
import GongyiCard from '../common/gongyi-card.vue';
import SvgIcon from '@/components/common/svg-icon.vue';

export default defineComponent({
  name: 'HonoraryItemModule',
  props: {
    /** 荣誉等级 */
    level: {
      type: Number,
      default: 0,
    },
    /** 当前等级印花目标数 */
    target: {
      type: Number,
      default: 0,
    },
    /** 荣誉昵称 */
    nickName: {
      type: String,
      default: 0,
    },
    /** 是否已完成该等级目标 */
    completed: {
      type: Boolean,
      default: false,
    },
    /** 是否已完成上一等级目标 */
    isPrevCompleted: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: '',
    },
  },
  components: { GongyiCard, SvgIcon },
  setup(props) {
    const levelDesc = computed(() => `0${props.level}`);
    return {
      levelDesc,
    };
  },
});
